<template>
  <div id="footer_link">
    <nav class="inner">
      <ul class="lst-link_group">
        <li class="lnk-web_main">
          <a href="https://35s.co.jp/chukyotvh/" target="_blank">
            <p>中京テレビハウジングWEBサイトへ</p>
          </a>
        </li>
        <li class="komaki">
          <a href="https://35s.co.jp/chukyotvh/venue_komaki/" target="_blank">
            <p>小牧会場</p>
          </a>
        </li>
        <li class="oobu">
          <a href="https://35s.co.jp/chukyotvh/venue_obu/" target="_blank">
            <p>大府会場</p>
          </a>
        </li>
        <li class="nishio">
          <a href="https://35s.co.jp/chukyotvh/venue_nishio/" target="_blank">
            <p>西尾会場</p>
          </a>
        </li>
        <li class="toyohashi">
          <a href="https://35s.co.jp/chukyotvh/venue_toyohashi/" target="_blank">
            <p>豊橋南会場</p>
          </a>
        </li>
      </ul>
    </nav>
    <div class="box-banner out inner">
      <figure>
        <a href="https://100ie-jiten.com/" target="_blank"><img src="../assets/img/banner/bnr-hyakka.jpg" width="1000" height="140" alt="百家辞典 理想のお家の実例参考書"></a>
      </figure>
    </div>
    <div class="box-banner inner">
      <section id="banner">
        <h2>中京テレビハウジングで開催中の<br class="hidden-md">オススメメニュー</h2>
        <!-- <figure class="top">
          <a href="https://35s.co.jp/chukyotvh/menu/dangan" target="_blank"><img src="https://100ie-jiten.com/wp-content/themes/hyakka/img/banner/ban_pick-up_01.jpg" width="1000" height="140" alt="モデルハウス弾丸ツアー"></a>
          <figcaption>
          短時間でイッキに見学！見学アンケートも不要！<br>モデルハウス弾丸ツアーなら効率的に見学できます。
        </figcaption>
        </figure> -->
        <figure>
          <a href="https://35s.co.jp/chukyotvh/menu/kattemi" target="_blank"><img src="https://100ie-jiten.com/wp-content/themes/hyakka/img/banner/ban_pick-up_02.png" width="1000" height="140" alt="中京テレビハウジング モデルハウス勝手に見学DAY"></a>
          <figcaption>
          自分たちで自由に気軽に見比べたい！<br>モデルハウス勝手に見学DAYなら個人情報アンケート不要で気軽に見学できます。
        </figcaption>
        </figure>
        <figure>
          <a href="https://35s.co.jp/chukyotvh/menu/supportcounter/" target="_blank"><img src="https://100ie-jiten.com/wp-content/themes/hyakka/img/banner/ban_pick-up_04.jpg" width="1000" height="140" alt="家づくりサポートカウンター"></a>
          <figcaption>
            住宅会社に属さない中立的な立場のアドバイザーが、注文住宅の購入検討に関する無料支援を行うサービスです。<br>具体的な検討がまだ先の方でも、これから計画するときの備えとして、お気軽にご参加ください。
        </figcaption>
        </figure>
        <figure>
          <a href="https://35s.co.jp/chukyotvh/menu/reservation/" target="_blank"><img src="https://100ie-jiten.com/wp-content/themes/hyakka/img/banner/bnr_reserve_kengaku.jpg" width="1000" height="140" alt="モデルハウス見学予約いま、モデルハウス見学予約が便利です。"></a>
          <figcaption>
          モデルハウス見学を事前にWEBから予約すると、便利でお得！<br>素敵なプレゼントもご用意しております。
        </figcaption>
        </figure>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BnrArea',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

